import "./MobileAppAside.scss";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import OrderingMenuIcon from "../icons/OrderingMenuIcon";
import MyBrandIcon from "../icons/MyBrandIcon";
import DisplayIconBlack from "../icons/DisplayIconBlack";
import LinkPagesIconBlack from "../icons/LinkPagesIconBlack";
import { env } from "../../env/env";
import LocationDropdown from "../LocationDropdown";
import { LocationDto, MemberDto, MemberDtoPlanEnum, MemberDtoRoleEnum } from "../../generated/dashboard-client";
import React, { useContext, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {memberState} from "../../state/atoms";
import SavedDesignsIcon from "../icons/SavedDesignsIcon";
import BrandKitIcon from "../icons/BrandKitIcon";
import {
  SettingOutlined,
  CreditCardOutlined,
  DollarCircleOutlined,
  PrinterOutlined,
  QuestionCircleOutlined,
  RightOutlined,
  LeftOutlined,
  UserOutlined
} from "@ant-design/icons";
import ChangeLocationIcon from "../icons/ChangeLocationIcon";
import UserIcon from "../icons/UserIcon";
//import UploadIcon from "../icons/UploadIcon";
import { Button } from "antd";
import { OmInUseModal } from "../om/OmInUseModal";
import CartIcon from "../icons/CartIcon";
import {HELP_CENTER_URL, homePaths, isTestEnv} from "../../util/constants";
import OrdersApi from "../../api/OrdersApi";
import { AppContext } from "../../AppContext";
import { synchronousRequest } from "../../util/utils";
import { isProSubscription } from "../../service/BillingService";
import DiningRDIcon from "../icons/DiningRDIcon";
import MobileProductDropdown from "./MobileProductDropdown";

interface MobileAppAsideProps {
  activeLocation: LocationDto;
  closeDrawer: () => void;
  cartCount: number;
  setCartCount: any;
  users: MemberDto[];
}

enum AsideMode {
  Dashboard,
  Account,
  Hidden,
}

export default function MobileAppAside({
  activeLocation,
  closeDrawer,
  cartCount,
  setCartCount,
  users
}: MobileAppAsideProps) {
  const loc = useLocation();

  const { location } = useContext(AppContext);
  const member = useRecoilValue(memberState);
  const [mode, setMode] = useState(AsideMode.Dashboard);
  const [isOoLoading, setOoLoading] = useState(false);
  const [isOoInUse, setOoInUse] = useState(false);
  const navigate = useNavigate();
  const [isPricingMenu, setPricingMenu] = useState(false);
  const [isProductMenu, setProductMenu] = useState(false);
  const [isWhoWeServeMenu, setWhoWeServeMenu] = useState(false);
  const [isResourcesMenu, setResourcesMenu] = useState(false);

  useEffect(() => {
    if (loc.pathname.indexOf("/account") > -1) {
      setMode(AsideMode.Account);
    } else {
      setMode(AsideMode.Dashboard);
    }
  }, [loc]);

  useEffect(() => {
    if (!location || !location.internalId) return;

    if (env.debug) {
      OrdersApi.getDraftItemsCount(location.internalId!).then((resp) => {
        setCartCount(resp.data);
      });
    }
  }, [member, location, setCartCount])

  function onOnlineMenuClick() {
    if (!isProSubscription(member)) {
      navigate(`${env.dashboardPath}/online-menus/`);
      closeDrawer();
      return;
    }

    setOoLoading(true);
    closeDrawer();

    setTimeout(() => {
      const resp = synchronousRequest(`/app/online/location/stats/${activeLocation.internalId!}?oo=true`);
      let location: any | null = null;
      if (resp) {
        try {
          location = JSON.parse(JSON.parse(resp).data).location;
        } catch (e) {
          console.error(e);
        }
      }

      if (location?.inUse) {
        setOoInUse(true);
        setOoLoading(false);
      } else {
        const base = isTestEnv ? 'https://test.mhmfun.com' : 'https://ohbz.com';//window.location.href.indexOf("staging.") > -1 ? "https://www.musthavemenus.com" : env.basePath;
        const tkn = window.localStorage.getItem("tkn");
        window.open(`${base}${env.ooContextPath}?businessId=${activeLocation.internalId}&tkn=${tkn}`, '_blank');
        setOoLoading(false);
      }
    }, 200);
  }

  function bookDemoClick() {
    window.open('/feature/book-demo-auth.html', '_blank');
  }

  function goToTeam() {
    window.location.href = `${env.dashboardPath}/account/team`;
  }

  function togglePricing(ev: React.MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    setPricingMenu(!isPricingMenu);
  }

  function toggleProduct(ev: React.MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    setProductMenu(!isProductMenu);
  }

  function toggleWhoWeServe(ev: React.MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    setWhoWeServeMenu(!isWhoWeServeMenu);
  }

  function toggleResources(ev: React.MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    setResourcesMenu(!isResourcesMenu);
  }

  return (
    <>
      {mode !== AsideMode.Hidden && (
        <div className={"aside-mobile"}>
          {mode === AsideMode.Dashboard && (
            <>
              {member.id && <LocationDropdown location={activeLocation} users={users} />}
              <nav>
                {member.id &&
                <ul>
                  <li>
                    <NavLink
                      to={`${env.dashboardPath}/designs/${activeLocation.internalId}`}
                      className={
                        homePaths.includes(window.location.pathname)
                          ? "active"
                          : ""
                      }
                      onClick={closeDrawer}
                    >
                      <SavedDesignsIcon />
                      Saved Designs
                    </NavLink>
                  </li>
                  {false && activeLocation.hasBrandTemplates && (
                    <li>
                      <NavLink
                        to={`${env.dashboardPath}/brand-templates/${activeLocation.internalId}`}
                        className={
                          window.location.pathname.indexOf("brand-templates") > -1
                            ? "active"
                            : ""
                        }
                        onClick={closeDrawer}
                      >
                        <BrandKitIcon />
                        Brand Templates
                      </NavLink>
                    </li>
                  )}
                  {!member.updateDrd && <li className={!isProSubscription(member) ? 'gray-out' : ''}>
                    <NavLink to={`${env.dashboardPath}/dsa/manage`}>
                      <DisplayIconBlack/>
                      <span>Display</span>
                      {!isProSubscription(member) &&
                      <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
                    </NavLink>
                  </li>}
                  {!member.updateDrd && <li className={!isProSubscription(member) ? 'gray-out' : ''}>
                    <Button
                      onClick={onOnlineMenuClick}
                      type={"link"}
                      loading={isOoLoading}
                      className={loc.pathname.indexOf("online-menus") > -1 ? "active" : ""}
                    >
                      {!isOoLoading && <OrderingMenuIcon />}
                      <span>Mobile Menus</span>
                      {!isProSubscription(member) &&
                      <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
                    </Button>
                  </li>}
                  {!member.updateDrd && <li className={!isProSubscription(member) ? 'gray-out' : ''}>
                    <NavLink
                      to={`${env.dashboardPath}/link-pages/${activeLocation.internalId}`}
                      onClick={closeDrawer}
                    >
                      <LinkPagesIconBlack />
                      <span>Link Pages</span>
                      {!isProSubscription(member) &&
                      <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
                    </NavLink>
                  </li>}
                  {!member.updateDrd && (member.owner || member.role === "Admin" || (member as any).manageBrand) && <li>
                    <NavLink
                      to={`${env.dashboardPath}/brand/${activeLocation.internalId}`}
                      onClick={closeDrawer}
                    >
                      <MyBrandIcon />
                      <span>Brand</span>
                    </NavLink>
                  </li>}
                  <div className={"separator"}></div>
                  <li className="wide-svg">
                    <a href={HELP_CENTER_URL} rel="external" onClick={closeDrawer}>
                      <QuestionCircleOutlined />
                      Help Center
                    </a>
                  </li>
                  {!member.updateDrd && <li>
                    <NavLink
                      to={env.dashboardPath + "/print/checkout"}
                      onClick={closeDrawer}
                    >
                      <CartIcon />
                      Print Cart&nbsp;{cartCount > 0 && <span className={"cart-count"}>({cartCount})</span>}
                    </NavLink>
                  </li>}

                  <div className="btn-container">
                    {/*<div className="btn-container menu-services-ad">
                      <span>20% Off<br/>Print Orders!</span>
                      <span>Use coupon "<b>print20</b>"</span>
                    </div>*/}
                    {/*<div className="btn-container menu-services-ad">
                      <span>50% off Sale!</span>
                      <Button onClick={goToDesignServices} className={"primary ds-btn"}>
                        <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushWhite.svg" alt="white paintbrush" />
                        Menu Services
                      </Button>
                    </div>*/}
                    {(member.owner || member.role === "Admin" as MemberDtoRoleEnum) && isProSubscription(member) &&
                    <div className={"add-team-btn"}>
                      <Button onClick={goToTeam} className={"secondary-two add-team"}>
                        <UserOutlined/>
                        Add Your Team
                      </Button>
                    </div>}
                  </div>
                </ul>}

                {!member.id && <>
                  {isProductMenu &&
                  <MobileProductDropdown toggleProduct={toggleProduct}/>}

                  {isWhoWeServeMenu &&
                  <ul>
                    <li className="header" onClick={(ev: any) => toggleWhoWeServe(ev)}>
                      <LeftOutlined/>
                      <span>Who We Serve</span>
                    </li>
                    <li>
                      <a href="/feature/restaurant-groups.html">
                        Restaurant Groups
                      </a>
                    </li>
                    <li>
                      <a href="/feature/hotels.html">
                        Hotels & Resorts
                      </a>
                    </li>
                    <li>
                      <a href="/feature/senior-living.html">
                        Senior Living
                      </a>
                    </li>
                  </ul>}

                  {isResourcesMenu &&
                  <ul>
                    <li className="header" onClick={(ev: any) => toggleResources(ev)}>
                      <LeftOutlined/>
                      <span>Resources</span>
                    </li>
                    <li>
                      <a href="/feature/case-studies.html">
                        Case Studies
                      </a>
                    </li>
                    <li>
                      <a href="/feature/blog">
                        Blog
                      </a>
                    </li>
                  </ul>}

                  {isPricingMenu &&
                  <ul>
                    <li className="header" onClick={(ev: any) => togglePricing(ev)}>
                      <LeftOutlined/>
                      <span>Pricing</span>
                    </li>
                    <li>
                      <a href="/menu/pricing.do">
                        Pricing Plans
                      </a>
                    </li>
                    <li>
                      <a href="/feature/musthavemenus-vs-competitors.html">
                        MustHaveMenus vs Competitors
                      </a>
                    </li>
                  </ul>}

                  {!isPricingMenu && !isProductMenu && !isWhoWeServeMenu && !isResourcesMenu &&
                  <>
                    <ul>
                      <li onClick={(ev: any) => toggleProduct(ev)}>
                        <div className="a-container">
                          Product <span className="expand expand-solutions"><RightOutlined/></span>
                        </div>
                      </li>

                      <li onClick={(ev: any) => toggleWhoWeServe(ev)}>
                        <div className="a-container">
                          Who We Serve <span className="expand"><RightOutlined/></span>
                        </div>
                      </li>

                      <li onClick={(ev: any) => togglePricing(ev)}>
                        <div className="a-container">
                          Pricing <span className="expand"><RightOutlined/></span>
                        </div>
                      </li>

                      <li onClick={(ev: any) => toggleResources(ev)}>
                        <div className="a-container">
                          Resources <span className="expand"><RightOutlined/></span>
                        </div>
                      </li>
                    </ul>
                    <div className="full-btn demo-btn log-in-btn">
                      <Button href={"/account/login"} onClick={closeDrawer} className={"primary"}>
                        Log In
                      </Button>
                    </div>
                    <div className="full-btn demo-btn">
                      <Button onClick={bookDemoClick} className={"primary"}>
                        Book a Demo
                      </Button>
                    </div>
                  </>}
                </>}
              </nav>
            </>
          )}

          {mode === AsideMode.Account && (
            <>
              <nav className={"account-aside"}>
                <ul>
                  <li>
                    <NavLink
                      className={"user-info"}
                      to={env.dashboardPath + "/account/users"}
                      onClick={closeDrawer}
                    >
                      <SettingOutlined />
                      User Info
                    </NavLink>
                  </li>
                  {member.plan !== MemberDtoPlanEnum.Free && member.owner && (
                    <li>
                      <NavLink
                        className={"billing-info"}
                        to={env.dashboardPath + "/account/billing"}
                        onClick={closeDrawer}
                      >
                        <CreditCardOutlined />
                        Billing Info
                      </NavLink>
                    </li>
                  )}
                  {member.owner && (
                    <li>
                      <NavLink
                        className={"subscription"}
                        to={env.dashboardPath + "/account/plan"}
                        onClick={closeDrawer}
                      >
                        <DollarCircleOutlined />
                        Subscription
                      </NavLink>
                    </li>
                  )}
                  {member.owner && (
                    <li className={!isProSubscription(member) ? 'gray-out' : ''}>
                      <NavLink
                        className={"locations"}
                        to={env.dashboardPath + "/account/locations"}
                        onClick={closeDrawer}
                      >
                        <ChangeLocationIcon />
                        Locations
                        {!isProSubscription(member) &&
                        <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
                      </NavLink>
                    </li>
                  )}
                  {member.owner && (
                    <li className={!isProSubscription(member) ? 'gray-out' : ''}>
                      <NavLink
                        className={"team"}
                        to={env.dashboardPath + "/account/team"}
                        onClick={closeDrawer}
                      >
                        <UserIcon />
                        Team
                        {!isProSubscription(member) &&
                        <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
                      </NavLink>
                    </li>
                  )}
                  {member.owner && (
                    <li>
                      <NavLink
                        className={"print-history"}
                        to={env.dashboardPath + "/account/print"}
                        onClick={closeDrawer}
                      >
                        <PrinterOutlined />
                        Print History
                      </NavLink>
                    </li>
                  )}
                  {member.owner && member.diningRDIntegration && (
                    <li>
                      <NavLink
                        className={"drd"}
                        to={env.dashboardPath + "/account/drd"}
                        onClick={closeDrawer}
                      >
                        <DiningRDIcon />
                        DiningRD Integration
                      </NavLink>
                    </li>
                  )}
                </ul>
              </nav>
            </>
          )}
        </div>
      )}

      <OmInUseModal
        isVisible={isOoInUse}
        onClose={() => {
          setOoInUse(false);
          setOoLoading(false);
        }}
      />
    </>
  );
}
